export const IMAGE_URL = "https://admin.zums.edu.bd/storage";
